/* eslint-disable new-cap */

import axios from 'axios';

export async function uploadImageToSwagger(imageBlob, id) {
  if (!imageBlob) {
    console.error('[uploadImageToSwagger] Error: No image blob provided');
    throw new Error('No image file provided');
  }

  if (!id) {
    console.error('[uploadImageToSwagger] Error: No task ID provided');
    throw new Error('No task ID provided');
  }

  try {
    const token = localStorage.getItem('token')
    if (!token) {
      console.error('[uploadImageToSwagger] Error: No authentication token found');
      throw new Error('Authentication token not found. Please login again.');
    }

    const url = `${process.env.REACT_APP_API_URL}image-upload-new/${id}/,/,/,`;
    console.log('[uploadImageToSwagger] Uploading image to:', url);
    
    const apiType = 'image';
    const formData = new FormData();
    formData.append(apiType, imageBlob);
    
    const myHeader = {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    
    const response = await axios.post(url, formData, { headers: myHeader });
    console.log('[uploadImageToSwagger] Upload successful:', response?.data);
    return response?.data;
  } catch (error) {
    console.error('[uploadImageToSwagger] Upload failed:', error);
    console.error('[uploadImageToSwagger] Error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    
    // Throw a more descriptive error
    if (error.response) {
      throw new Error(`Image upload failed: ${error.response?.data?.message || error.response?.statusText || 'Server error'}`);
    } else if (error.request) {
      throw new Error('Image upload failed: No response from server. Please check your network connection.');
    } else {
      throw new Error(`Image upload failed: ${error.message}`);
    }
  }
}
export async function finalImageUpload(object, taskId) {
  if (!object) {
    console.error('[finalImageUpload] Error: No data object provided');
    throw new Error('No upload data provided');
  }

  if (!taskId) {
    console.error('[finalImageUpload] Error: No task ID provided');
    throw new Error('No task ID provided');
  }

  // Validate required fields
  if (!object.img1) {
    console.error('[finalImageUpload] Error: Missing image path');
    throw new Error('Image path is missing');
  }

  if (!object.lat || !object.long) {
    console.error('[finalImageUpload] Error: Missing coordinates', { lat: object.lat, long: object.long });
    throw new Error('Latitude and longitude are required');
  }

  if (!object.time || !object.date) {
    console.error('[finalImageUpload] Error: Missing time/date', { time: object.time, date: object.date });
    throw new Error('Time and date are required');
  }

  try {
    const finalObj = {
      img1: object.img1,
      img2: '',
      img3: '',
      img4: '',
      videoUrl: '',
      videoUrl1: '',
      vendorRemark: '',
      problemWithSite: false,
      lat: object.lat,
      long: object.long,
      latImg1: object.lat,
      longImg1: object.long,
      reportedTime: `${object.date}T${object.time}:33+05:30`,
    }
    
    const token = localStorage.getItem('token')
    if (!token) {
      console.error('[finalImageUpload] Error: No authentication token found');
      throw new Error('Authentication token not found. Please login again.');
    }

    const url = `${process.env.REACT_APP_API_URL}sites/submit/${taskId}`;
    console.log('[finalImageUpload] Submitting final upload to:', url);
    console.log('[finalImageUpload] Payload:', finalObj);
    
    const body = finalObj;
    const myHeader = {
      Authorization: `Bearer ${token}`,
    };
    
    const response = await axios.post(url, body, {
      headers: myHeader,
    });
    
    console.log('[finalImageUpload] Upload successful:', response?.data);
    return response
  } catch (error) {
    console.error('[finalImageUpload] Upload failed:', error);
    console.error('[finalImageUpload] Error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    
    // Throw a more descriptive error
    if (error.response) {
      throw new Error(`Final upload failed: ${error.response?.data?.message || error.response?.statusText || 'Server error'}`);
    } else if (error.request) {
      throw new Error('Final upload failed: No response from server. Please check your network connection.');
    } else {
      throw new Error(`Final upload failed: ${error.message}`);
    }
  }
}

export default { uploadImageToSwagger, finalImageUpload }
